import { render, staticRenderFns } from "./SidebarItemBody.vue?vue&type=template&id=788b4ba2&"
import script from "./SidebarItemBody.vue?vue&type=script&lang=js&"
export * from "./SidebarItemBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports